/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Fetcher,
  HttpMethod,
  RequestContext,
  ResponseContext,
} from '@typoas/runtime';
import {
  CreateVenueParams,
  CreateVenueResponse,
  ErrorType,
  GetJobStatusResponse,
  GetVenueResponse,
  JobStatus,
} from './client';

const existingEmails = [
  'test@treatwell.com',
  'test2@treatwell.com',
  'foo@bar.com',
];

const activeCustomers = ['test2@treatwell.com', 'foo@bar.com'];

const mockVenues = [
  {
    name: 'Treatwell',
    address: {
      street: '32 rue du Louvre',
      city: 'Paris',
      postalCode: '75001',
      countryCode: 'FR',
    },
    loginRedirectURL: 'https://connect.treatwell.fr',
  },
  {
    name: 'Treatwell',
    address: {
      street: '15 Fulwood Place',
      city: 'London',
      postalCode: 'WC1V 6HU',
      countryCode: 'GB',
    },
    loginRedirectURL: 'https://connect.treatwell.co.uk',
  },
  {
    name: 'Sam la coupe',
    address: {
      street: '28 rue des Chauves',
      city: 'Lens',
      postalCode: '62300',
      countryCode: 'FR',
    },
    loginRedirectURL: 'https://pro.treatwell.fr/',
  },
  {
    name: 'Sam la coupe est belle',
    address: {
      street: '38 rue des Cheveux',
      city: 'Le Mans',
      postalCode: '72100',
      countryCode: 'FR',
    },
    loginRedirectURL: 'https://pro.treatwell.fr/',
  },
  {
    name: 'Sammy coiffure',
    address: {
      street: '2807 rue de la Coiffure',
      city: 'Mauzé-sur-le-Mignon',
      postalCode: '79170',
      countryCode: 'FR',
    },
  },
];

function getVenueResponse(email: string): GetVenueResponse {
  if (activeCustomers.includes(email.toLowerCase())) {
    return {
      redirectURL: 'https://connect.treatwell.fr',
    };
  }
  return {
    redirectURL: null,
  };
}

function getJobStatusResponse(): GetJobStatusResponse {
  const status = Math.random() > 0.5 ? JobStatus.SUCCESS : JobStatus.PENDING;
  return {
    status,
  };
}

function postSignUp(params: CreateVenueParams): CreateVenueResponse {
  const errors: CreateVenueResponse['errors'] = [];

  const namesTaken = mockVenues.map(v => v.name);
  if (namesTaken.includes(params.businessName)) {
    errors.push({
      type: ErrorType.ALREADY_EXISTS,
      key: 'businessName',
    });
  }

  if (existingEmails.includes(params.email)) {
    errors.push({
      type: ErrorType.ALREADY_EXISTS,
      key: 'email',
    });
  }

  return {
    errors,
    jobId: '1234',
  };
}

function getResponse(request: RequestContext) {
  if (
    request.getHttpMethod() === HttpMethod.GET &&
    request.getUrl().includes('job')
  ) {
    return getJobStatusResponse();
  }
  if (request.getHttpMethod() === HttpMethod.GET) {
    // @ts-expect-error private field
    return getVenueResponse(request.url.query.email);
  }
  // @ts-expect-error private field
  return postSignUp(JSON.parse(request.body));
}

export class MockFetcher implements Fetcher {
  async send(request: RequestContext): Promise<ResponseContext> {
    const response = await getResponse(request);

    await new Promise(resolve =>
      setTimeout(
        resolve,
        // delay between 1000 and 1150ms
        Math.round(Math.random() * 150) + 1000,
      ),
    );

    return new ResponseContext(
      200,
      { 'content-type': 'application/json' },
      {
        async text() {
          throw new Error('Not implemented');
        },
        async binary() {
          throw new Error('Not implemented');
        },
        async json() {
          return response;
        },
      },
    );
  }
}
